import { USER_ROLE } from '@interfaces/userManagement/enums/userRole'

interface IUserPageProperties {
    listTitle: string,
    updateTitle: string,
    createTitle: string,
    buttonLabel?: string,
    buttonLink?: string,
    baseUrl: string,
}

const userRoleParameters: Record<USER_ROLE, IUserPageProperties> = {
    [USER_ROLE.ADMIN]: {
        listTitle: 'Usuários Admin',
        updateTitle: 'Editar Usuário',
        createTitle: 'Novo Usuário',
        buttonLabel: 'Novo Usuário',
        buttonLink: '/administradores/novo',
        baseUrl: '/administradores',
    },
    [USER_ROLE.CLIENT]: {
        listTitle: 'Clientes',
        updateTitle: 'Editar Clientes',
        createTitle: 'Novo Cliente',
        buttonLabel: 'Novo Cliente',
        buttonLink: '/clientes/novo',
        baseUrl: '/clientes',
    },
    [USER_ROLE.REALTOR]: {
        listTitle: 'Corretores',
        updateTitle: 'Editar Corretor',
        createTitle: 'Novo Corretor',
        baseUrl: '/corretores',
    },
}

export default userRoleParameters